import { registerPlugin } from "@capacitor/core";

export interface SystemUiPlugin {
  /**
   * Hides the Android system bars (bottom navigation bar with back/home/apps
   * icons, and the top status bar) — kiosk-style fullscreen for the
   * Attendance Tablet scanning screen.
   */
  hideBars(): Promise<void>;
  /**
   * Restores the Android system bars after hideBars().
   */
  showBars(): Promise<void>;
}

export const SystemUi = registerPlugin<SystemUiPlugin>("SystemUi");
